export const initialState = {
  user: [],
  employees: [],
  supervisors: [],
  clients: [],
  tasks: [],
  jobs: [],
  assignedjobs: [],
  checkinstatus: [],
  blogs: [],
  users: [],
  leaves: [],
  projects: [],
  projectemployees: [],
  selectedtile: "Dashboard",
  projectsupervisors: [],
  allclients: [],
  project: "",
  designation: [],
  startdate: new Date(new Date().setHours(0, 0, 0, 0)),
  enddate: new Date(new Date().setHours(23, 59, 59, 59)),
  employeeid: 0,
  employeedata: {},
  language: 1,
  notificationslotdata: {},
  adminclients: [],
};
